/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const callApiWithToken = async(accessToken, apiEndpoint) => {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(apiEndpoint, options)
        .then(response => response.json())
        .catch(error => error);
}

export const postApiWithToken = async(accessToken, apiEndpoint, body) => {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json")

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };

    return fetch(apiEndpoint, options)
        .then(response => response.json())
        .catch(error => error);
}

export const queryApiWithToken = async(accessToken, apiEndpoint, params, useURLEncoding = true) => {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json")
    if(!useURLEncoding) {
        headers.append("ConsistencyLevel", "Eventual")
    }
    

    const options = {
        method: "GET",
        headers: headers
    };

    let url = "";

    if(useURLEncoding) {
        url = apiEndpoint + '?' + ( new URLSearchParams( params ) ).toString();
    } else {
        url = apiEndpoint + '?' + params;
    }

    return fetch(url, options)
        .then(response => response.json())
        .catch(error => error);
}